import React from 'react';

const IcebergerSafety2026 = () => {
  return (
    <div>
      <h1>IceBerger Safety 2026</h1>
      <p>Brighton Icebergers Winter Safety Initiative, 2026. Pre-winter presentation to Icebergers. </p>
      <p>
        <a
          href="/Iceberger_Safety_2026.pdf"
          download="Iceberger_Safety_2026.pdf"
          style={{ fontSize: '18px' }}
        >
          Download: IceBerger Safety 2026 Presentation (PDF)
        </a>
      </p>
      <p>
        <a
          href="/blogs/PreSwimPersonalRiskAssessment"
          style={{ fontSize: '18px' }}
        >
          Also see the Pre-Swim Personal Risk Assessment & Safety Checklist
        </a>
      </p>
      
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default IcebergerSafety2026;